/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guest_Picker_Adults_HintInputs */

const en_guest_picker_adults_hint = /** @type {(inputs: Guest_Picker_Adults_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ages 18 and up`)
};

/**
* | output |
* | --- |
* | "Ages 18 and up" |
*
* @param {Guest_Picker_Adults_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const guest_picker_adults_hint = /** @type {((inputs?: Guest_Picker_Adults_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guest_Picker_Adults_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_guest_picker_adults_hint(inputs)
});